export default {
  getInstitucionTpl: state => {
    let table = 'Institucion'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
